import { GivingStatementsApiConfig } from './giving-statements-generated';
import { dataService } from '../../Shared/utils/data-service';

const ds = dataService(GivingStatementsApiConfig).getSagaService();

export const givingStatementsDataService = ds;
